const TOTAL_FRAMES = 75;
let isPreloaded = false;
const preloadedImages: HTMLImageElement[] = [];

export const preloadConfettiImages = async () => {
    if (isPreloaded) return preloadedImages;

    const promises: Promise<void>[] = [];

    for (let i = 1; i <= TOTAL_FRAMES; i++) {
        const padded = String(i).padStart(4, "0");
        const path = `/images/confettiImages/masked${padded}.webp`;

        const img = new Image();
        img.src = path;

        const promise = new Promise<void>((resolve, reject) => {
            img.onload = () => resolve();
            img.onerror = () => reject(`Failed to load image: ${path}`);
        });

        preloadedImages.push(img);
        promises.push(promise);
    }

    await Promise.all(promises);
    isPreloaded = true;
    return preloadedImages;
};
